import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {Container, BorderContainer, Title, Small, BorderContainerWrapper, Button} from './styles';

const PointsBlock = ({points, points_expiration}) => (
  <Container>
    <BorderContainerWrapper>
      <BorderContainer>
        <Title>
          Vous avez
          <br /> actuellement
          <br /> {points} points
        </Title>
        <Small>
          Valables jusqu’au 
          {points_expiration}
        </Small>
        <Link
          to="/gifts/more-points"
          style={{textDecoration: 'none', width: '100%', textAlign: 'center'}}>
          <Button color="white">Comment obtenir plus de points ?</Button>
        </Link>
      </BorderContainer>
    </BorderContainerWrapper>
  </Container>
);

PointsBlock.propTypes = {
  points: PropTypes.number,
  points_expiration: PropTypes.string,
};

export default PointsBlock;
